import * as CL from '@design-system/component-library';
import type * as CLT from '@design-system/component-library';

import './Combobox.scss';

// This Combobox component gives a style to the CL.Combobox that will
// hide the placeholder text from a combobox list that is by default added into the
// combobox list as a selectable item.
// This is a workaround and should be removed once the CL.Combobox supports similar approach.
export const Combobox = (props: CLT.ComboboxProps) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { className, ref, selectedValue, ...rest } = props;
  const hasValue = selectedValue !== undefined && selectedValue !== null && selectedValue !== ''; // Simplified to rely on !!selectedValue to handle all falsy cases
  const classes = `of-combobox ${!hasValue ? 'of-combobox--placeholder' : ''} ${className ?? ''}`.trim();
  return <CL.Combobox className={classes} selectedValue={selectedValue} {...rest} />;
};
